import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import ModulosView from './ModulosView';
import * as ROUTES from '../../../router/Routes';

const ModulosModule = () => {
  return (
    <ContainerTemplate active={ROUTES.modulos} routes={[ROUTES.root]}>
      <ModulosView />
    </ContainerTemplate>
  );
};

export default ModulosModule;
